import { render, staticRenderFns } from "./CompositePackage.vue?vue&type=template&id=5511698c&scoped=true&"
import script from "./CompositePackage.vue?vue&type=script&lang=js&"
export * from "./CompositePackage.vue?vue&type=script&lang=js&"
import style0 from "./CompositePackage.vue?vue&type=style&index=0&id=5511698c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5511698c",
  null
  
)

export default component.exports